export const ebAppEvent = (eventName: String, payload: Record<string, any>) => {
  if (window && typeof window.ebappevent !== 'undefined') {
    window.ebappevent('guest_email_added', payload);
  }
};
